import React from 'react';
import { FormFeedback, Input } from 'reactstrap';

function ReadOnlyInput(props) {
  return (
    <>
      <Input disabled {...props} />

      {props.touched?.details && props.errors?.details ? (
        <FormFeedback type="invalid">
          {props.errorMessage}
        </FormFeedback>
      ) : null}
    </>
  );
}

export default ReadOnlyInput;